import {PAGE_PATHS} from 'pages';
import {Simulation} from 'types';

export const createPathOfSimulationDetailsPage = (
	id: Simulation['id'],
): string => {
	return `${PAGE_PATHS.simulations}/${id}`;
};
